import clsx from 'clsx';
import type { InputHTMLAttributes } from 'react';

import styles from './Checkbox.module.scss';

type CheckboxProps = {
  label: string;
  sublabel?: string;
  /** Strikes the label through while checked: a step ticked off in a list stays readable. */
  strikethrough?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const Checkbox = ({ label, sublabel, strikethrough, className, id, ...props }: CheckboxProps) => {
  const checkboxId = id || `checkbox-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className={clsx(styles.checkboxWrapper, strikethrough && styles.strikethrough, className)}>
      <input type="checkbox" id={checkboxId} className={styles.checkbox} {...props} />
      <label htmlFor={checkboxId} className={styles.label}>
        <span className={styles.labelText}>{label}</span>
        {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
